namespace Matrix.Data {
    export class ClientFieldColumns {
        static columnsKey = 'Data.ClientField';
    }
}
